import React from 'react';

interface Props {
  onBack?: () => void;
  onComment?: () => void;
  onNext?: () => void;
  nextDisabled?: boolean;
  backLabel?: string;
  nextLabel?: string;
}

export default function Footer({ onBack, onComment, onNext, nextDisabled, backLabel = '戻る', nextLabel = '次へ' }: Props) {
  return (
    <div className="footer">
      {onBack
        ? <button className="footer-btn" onClick={onBack}>{backLabel}</button>
        : <div className="footer-btn-placeholder" />
      }
      {onComment
        ? <button className="footer-btn footer-btn-comment" onClick={onComment}>解説</button>
        : <div className="footer-btn-placeholder" />
      }
      {onNext
        ? <button className="footer-btn footer-btn-next" onClick={onNext} disabled={nextDisabled}>{nextLabel}</button>
        : <div className="footer-btn-placeholder" />
      }
    </div>
  );
}
